/**
 * Lectura BARATA de "sin conexión" para los hooks calientes (usePermissions,
 * useTableData, useCompanyContext, useCurrentUser, AuthGuard).
 *
 * A diferencia de `useConnectionStatus` (que se suscribe al estado del WebSocket
 * de Convex), esto NO se suscribe a nada: solo lee `navigator.onLine` en render.
 * Es crítico para performance: `usePermissions` se instancia decenas/cientos de
 * veces, y suscribir cada instancia al connection-state provocaba una tormenta
 * de re-renders (cada nudge del ConnectionWatchdog re-renderizaba todo) que
 * bloqueaba el main thread y colgaba la app.
 *
 * La reactividad del fallback offline no la necesita esta señal: se evalúa al
 * re-renderizar (navegar/remontar, cuando la query queda `undefined`).
 *
 * Combina `navigator.onLine` con la señal del WS de Convex (isBackendKnownDown):
 * en el webview de escritorio `navigator.onLine` miente, y sin eso el gate de
 * auth quedaba colgado en un cold-start sin red.
 */
import { isBackendKnownDown } from "./connection-signal";

export function isOffline(): boolean {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  return isBackendKnownDown();
}
